export const categories = [
    { title: 'Actions', url: '/categories/actions' },
    { title: 'Adjectives', url: '/categories/adjectives' },
    { title: 'Animals', url: '/categories/animals' },
    { title: 'Anime', url: '/categories/anime' },
    { title: 'Art & Design', url: '/categories/art-design' },
    { title: 'Cartoons & Comics', url: '/categories/cartoons-comics' },
    { title: 'Celebrities', url: '/categories/celebrities' },
    { title: 'Decades', url: '/categories/decades' },
    { title: 'Emotions', url: '/categories/emotions' },
    { title: 'Fashion & Beauty', url: '/categories/fashion-beauty' },
    { title: 'Food & Drink', url: '/categories/food-drink' },
    { title: 'Gaming', url: '/categories/gaming' },
    { title: 'Greetings', url: '/categories/greetings' },
    { title: 'Holidays', url: '/categories/holiday' },
    { title: 'Identity', url: '/categories/identity' },
    { title: 'Interests', url: '/categories/interests' },
    { title: 'Memes', url: '/categories/memes' },
    { title: 'Movies', url: '/categories/movies' },
    { title: 'Music', url: '/categories/music' },
    { title: 'Nature', url: '/categories/nature' },
    { title: 'News & Politics', url: '/categories/news-politics' },
    { title: 'Reactions', url: '/categories/reactions' },
    { title: 'Science', url: '/categories/science' },
    { title: 'Sports', url: '/categories/sports' },
    { title: 'Stickers', url: '/categories/stickers' },
    { title: 'Transportation', url: '/categories/transportation' },
    { title: 'TV', url: '/categories/tv' },
    { title: 'Weird', url: '/categories/weird' },
]
